import { ErrorResponse } from '@Types/Response.types';
import { EXCEL_ASSET_FIELD_NAMES } from '@Utils/constants';
import { Toast } from '@kg-internal/pv3-uikit';
import axios, { AxiosError } from 'axios';
import { Dispatch, SetStateAction } from 'react';

export const sendCall = (url: string, config: Record<string, unknown>) => {
  const finalConfig = { ...config, ...{ withCredentials: true } };

  return axios(url, finalConfig);
};

const formatErrorMessage = (errorMessage: string, fields: string[]) => {
  let message = errorMessage;

  const split = errorMessage.split(': ');
  if (split.length > 1) {
    message = `${split[0]}:`;
  }

  const mappedFields = fields
    .map((field) => {
      if (EXCEL_ASSET_FIELD_NAMES[field]) {
        return EXCEL_ASSET_FIELD_NAMES[field];
      }
      return field;
    })
    .join(', ');

  return `${message} ${mappedFields}`;
};

export const handleRequestError = (
  error: AxiosError<ErrorResponse>,
  setError: Dispatch<SetStateAction<string | undefined>>,
  withToast = false,
) => {
  let errorMessage = '';
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    if (error.response.data.fields) {
      errorMessage = formatErrorMessage(error.response.data.message, error.response.data.fields);
    } else {
      errorMessage = error.response.data.message;
    }
  } else if (error.request) {
    // The request was made but no response was received
    errorMessage = 'Could not get a response from the server.';
  } else {
    // Something happened in setting up the request that triggered an Error
    errorMessage = `Unknown error. Error: ${error.message}`;
  }
  if (withToast) {
    Toast.warning(errorMessage);
  } else {
    setError(errorMessage);
  }
};
